var _path, _path2, _path3, _path4;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPeoplesIc(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8.66732 7.33332C8.66732 5.86056 7.47338 4.66666 6.00065 4.66666C4.52789 4.66666 3.33398 5.86056 3.33398 7.33332C3.33398 8.80606 4.52789 9.99999 6.00065 9.99999C7.47338 9.99999 8.66732 8.80606 8.66732 7.33332Z",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.35972 5.03849C7.34272 4.91698 7.33398 4.79285 7.33398 4.66667C7.33398 3.19391 8.52792 2 10.0007 2C11.4734 2 12.6673 3.19391 12.6673 4.66667C12.6673 6.13943 11.4734 7.33333 10.0007 7.33333C9.50425 7.33333 9.03958 7.19773 8.64158 6.96153",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M10 14C10 11.7909 8.20913 10 6 10C3.79086 10 2 11.7909 2 14",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M14 11.3333C14 9.12421 12.2091 7.33334 10 7.33334",
    stroke: "#172B4D",
    strokeWidth: 1.5,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPeoplesIc);
export default __webpack_public_path__ + "static/media/peoples_ic.4941456ea4341d44b2f0828923fc9728.svg";
export { ForwardRef as ReactComponent };